import { api, apiMipe } from '@/core/api/';
import qs from 'qs';

const apiUrl = 'api/vocationalevaluation';
const baseApiReport = '/api/report';

//catalogs
export const getImpediments = () =>
  apiMipe.get(`/api/triannualstudentevaluation/gettrianualfilteredimpediments`);
export const getOtherImpediments = (includeOhter = false) =>
  apiMipe.get(
    `/api/triannualstudentevaluation/eligibilitydeterminationconditions?includeOhter=${includeOhter}`
  );
export const getCommunicationTypes = () =>
  api.get(`${apiUrl}/catalogs/communication-methods`);
export const getRecords = () => api.get(`${apiUrl}/catalogs/records`);
export const getOptions = (types) =>
  api.get(`${apiUrl}/catalogs/options`, {
    params: { types },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: 'repeat' }),
  });

export const get = (params) => api.get(apiUrl, { params });
export const save = (payload) => api.post(apiUrl, payload);
export const changeStatus = (id, statusId) =>
  api.put(`${apiUrl}/${id}/change-status/${statusId}`);

export const getAppointment = (params) =>
  api.get(`${apiUrl}/tab/appointment`, { params });
export const getOnePartA = (params) =>
  api.get(`${apiUrl}/tab/one-part-a`, { params });
export const getOnePartB = (params) =>
  api.get(`${apiUrl}/tab/one-part-b`, { params });
export const getTabTwo = (params) => api.get(`${apiUrl}/tab/two`, { params });
export const getThreeToFour = (params) =>
  api.get(`${apiUrl}/tab/three-to-four`, { params });
export const getFive = (params) => api.get(`${apiUrl}/tab/five`, { params });
export const getSix = (params) => api.get(`${apiUrl}/tab/six`, { params });
export const getSeven = (params) => api.get(`${apiUrl}/tab/seven`, { params });
export const getEight = (params) => api.get(`${apiUrl}/tab/eight`, { params });
export const getNine = (params) => api.get(`${apiUrl}/tab/nine`, { params });
export const getTen = (params) => api.get(`${apiUrl}/tab/ten`, { params });
export const getSignature = (params) =>
  api.get(`${apiUrl}/tab/signature`, { params });
export const getInstrument = (id) => api.get(`${apiUrl}/instrument/${id}`);
export const saveInstrument = (id, payload) =>
  api.post(`${apiUrl}/instrument/${id}`, payload);
export const changeInstrumentStatus = (id, statusId = 1) =>
  api.put(`${apiUrl}/instrument/${id}/change-status/${statusId}`);
export const getDisabilityEvaluationQuestionnaireLevels = (typeId) =>
  api.get(`${apiUrl}/catalogs/instrument/whodas/levels/${typeId}`);
export const getReport = (id) =>
  api.get(`${baseApiReport}/vocationalevaluation/${id}`);
export const saveSignedDocument = (payload) =>
  api.post(`${apiUrl}/signed-document`, payload);
export const saveDocument = (id, payload) =>
  api.post(`${apiUrl}/${id}/document`, payload);
export const removeDocument = (id, documentId) =>
  api.delete(`${apiUrl}/${id}/document/${documentId}`);
